import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as DigitalBoardActions from './digital-board.actions';
import * as DigitalBoardSelectors from './digital-board.selectors';
import {Observable} from 'rxjs';
import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';

@Injectable()
export class DigitalBoardFacade {
	// UI agent subscribes to these observables
	readonly inPreparationOrders$: Observable<(Order | OrderPool)[]> =
		this.store.pipe(select(DigitalBoardSelectors.inPreparationOrders));

	readonly readyOrders$: Observable<(Order | OrderPool)[]> = this.store.pipe(
		select(DigitalBoardSelectors.readyOrders)
	);

	readonly loading$: Observable<boolean> = this.store.pipe(
		select(DigitalBoardSelectors.loading)
	);

	readonly error$: Observable<string | null> = this.store.pipe(
		select(DigitalBoardSelectors.error)
	);

	readonly loaded$: Observable<boolean> = this.store.pipe(
		select(DigitalBoardSelectors.loaded)
	);

	readonly venueId$: Observable<string | null> = this.store.pipe(
		select(DigitalBoardSelectors.venueId)
	);

	constructor(private store: Store) {}

	/**
	 * UI agent calls this on page load
	 * @param venueId The venue ID to load board data for
	 */
	loadBoardData(venueId: string): void {
		this.store.dispatch(DigitalBoardActions.loadDigitalBoardData({venueId}));
	}

	/**
	 * Internal method for socket updates - updates a single order
	 * @param order The order to update
	 */
	updateOrder(order: Order): void {
		this.store.dispatch(DigitalBoardActions.updateBoardOrder({order}));
	}

	/**
	 * Internal method for socket updates - updates a single order pool
	 * @param orderPool The order pool to update
	 */
	updateOrderPool(orderPool: OrderPool): void {
		this.store.dispatch(DigitalBoardActions.updateBoardOrderPool({orderPool}));
	}
}
